//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import { setPreciseAmount } from './ReportMaterialsHelperFunctions.js'
import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    record: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    operation: {
      type: String,
      default: null
    },
    // ====================
    serviceObject: {
      type: Object,
      default: () => {
        return { key: null }
      }
    },
    selectedSegment: {
      type: Object,
      default: null
    },
    isReplacementDemounting: {
      type: Boolean,
      default: false
    },
    sourceTableInput: {
      type: String,
      default: null
    },
    debits: {
      type: Array,
      default () {
        return []
      }
    },
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      mounting: null,

      availableAmount: null,
      materials: [],
      sourceTables: [
        { key: 'debit', name: 'Списание с мобильного склада' },
        { key: 'consumption', name: 'Расход вне склада' },
        { key: 'demounting', name: 'Списание со склада демонтажа' }
      ],
      operationMountingTables: [
        { key: 'debit', name: 'Списание с мобильного склада' },
        { key: 'consumption', name: 'Расход вне склада' }
      ],
      operationReplacementTables: [
        { key: 'debit', name: 'Списание с мобильного склада' },
        { key: 'consumption', name: 'Расход вне склада' },
        { key: 'demounting', name: 'Списание со склада демонтажа' }
      ],

      editedMaterial: null,
      toolFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getTools,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),

      units: [
        'шт',
        'упак',
        'пар',
        'компл',
        'м',
        'кг',
        'бут',
        'лист',
        'л',
        'м2',
        'м3',
        'рул',
        'мешок',
        'т',
        'гКал'
      ],
      setPreciseAmount: setPreciseAmount,

      optionsConsumptionDf: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        },
        {
          label: 'Не выбрано',
          value: null
        }
      ]
    }
  },
  computed: {
    disabledButtonSave: function () {
      let availableAmount = true
      if (this.mounting.sourceTable !== 'other' && this.availableAmount) {
        availableAmount = this.mounting.amount && (this.mounting.amount <= this.availableAmount)
      }
      return !(this.reportActionsAccess.editMaterials &&
            (this.mounting.toolName && this.mounting.sourceTable &&
            (this.mounting.amount && this.mounting.amount !== '' && this.mounting.amount > 0 && availableAmount) &&
            (this.mounting.unit && this.mounting.unit !== '')))
    }
  },
  watch: {
    'mounting.sourceTable': function () {
      this.prepareMaterials()
    }
  },
  created: function () {
    const mounting = {
      toolName: null,
      toolKey: null,
      amount: null,
      unit: null,
      sourceTable: null,
      recId: null,
      sn: null,
      tag: null,
      demountingId: null,
      isSegment: false
    }

    if (this.isEdit) {
      this.mounting = mounting

      const editedMounting = this.record
      this.mounting.sourceTable = editedMounting.sourceTable
      this.mounting.toolName = editedMounting.toolName
      this.mounting.toolKey = editedMounting.toolKey
      this.mounting.amount = editedMounting.amount
      this.mounting.unit = editedMounting.unit
      this.mounting.noted = editedMounting.noted
      this.mounting.note = editedMounting.note
      this.mounting.recId = editedMounting.recId
      this.mounting.sn = editedMounting.sn
      this.mounting.tag = editedMounting.tag
      this.mounting.demountingId = editedMounting.demountingId
      this.mounting.isSegment = editedMounting.isSegment

      if (editedMounting.sourceTable === 'other') {
        this.editedMaterial = {
          id: editedMounting.toolKey,
          name: editedMounting.toolName
        }
      } else {
        this.prepareMaterials()
        this.calculateAvailableAmountForEditedMounting(editedMounting)
      }
    } else {
      this.mounting = mounting

      if (this.sourceTableInput) {
        this.mounting.sourceTable = this.sourceTableInput
      } else {
        this.mounting.sourceTable = 'debit'
      }
    }
  },
  methods: {
    onAddMounting: function (operation, demountingId) {
      // TODO
    },
    onEditMounting: function (row) {
      // TODO
    },
    clearMaterial: function () {
      this.mounting.toolName = null
      this.mounting.toolKey = null
      this.mounting.amount = null
    },
    onSelectSourceTable: function () {
      this.clearMaterial()
    },
    prepareMaterials: function () {
      let tableRecords = []
      this.materials = []
      if (this.mounting.sourceTable === 'debit') {
        tableRecords = JSON.parse(JSON.stringify(this.debits))
      } else if (this.mounting.sourceTable === 'consumption') {
        tableRecords = JSON.parse(JSON.stringify(this.consumptions))
      } else if (this.mounting.sourceTable === 'demounting') {
        tableRecords = JSON.parse(JSON.stringify(this.demountings))
      }

      if (this.mounting.sourceTable === 'demounting') {
        tableRecords = tableRecords.filter(record => record.serviceObjectKey !== this.serviceObject.key || record.amount < 0)
      }

      if (this.mounting.sourceTable === 'debit' || this.mounting.sourceTable === 'consumption') {
        tableRecords = tableRecords.filter(record => !record.mountingId)
      }

      tableRecords.forEach(tableRecord => {
        const material = this.materials.find(material => {
          return material.toolKey === tableRecord.toolKey && material.sn === tableRecord.sn
        })
        if (material && (!this.isEdit || tableRecord.amount > 0)) {
          material.amount += tableRecord.amount
        } else {
          this.materials.push(tableRecord)
        }
      })

      this.$nextTick(() => {
        this.materials = this.materials.filter((material) => material.amount > 0)
      })
    },
    getTools: function (text = '') {
      const urlName = '/service/delta/fastsearch/searchInTreeByPattern?tree=dictTools&limit=100&pattern=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return (response.data && response.data.length) ? response.data : [{ id: text, name: text }]
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка загрузки списка материалов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка материалов'))
        }
      })
    },
    onSelectedMaterial: function (material) {
      if (material) {
        if (this.mounting.sourceTable === 'other') {
          if (material.id === material.name) {
            this.mounting.toolKey = null
            this.mounting.noted = 'hasNotes'
            this.mounting.note = 'Ручной ввод'
          } else {
            this.mounting.toolKey = material.id
          }
          this.mounting.toolName = material.name
        } else {
          this.mounting.toolKey = material.toolKey
          this.mounting.toolName = material.toolName
          this.mounting.unit = material.unit
          this.availableAmount = material.amount
          this.mounting.amount = null
          this.mounting.sn = material.sn
          this.mounting.tag = material.tag

          if (this.mounting.sourceTable === 'debit') {
            this.mounting.debitId = material.recId
          }
          if (this.mounting.sourceTable === 'consumption') {
            this.mounting.consumptionId = material.recId
          }
          if (this.mounting.sourceTable === 'demounting') {
            this.mounting.demountingId = material.recId
          }
        }
      } else {
        this.clearMaterial()
      }
    },
    calculateAvailableAmountForEditedMounting: function (mounting) {
      let availableAmount = 0
      for (let i = 0; i < this.materials.length; i++) {
        if (mounting.toolKey === this.materials[i].toolKey && mounting.sn === this.materials[i].sn) {
          availableAmount += this.materials[i].amount
        }
      }
      this.availableAmount = availableAmount + mounting.amount
    },
    onSaveMounting: function () {
      this.$emit('save', this.mounting)
      this.resetMounting()
    },
    onCloseMounting: function () {
      this.$emit('close')
      this.resetMounting()
    },
    resetMounting: function () {
      this.mounting.sourceTable = null
      this.mounting.toolName = null
      this.mounting.toolKey = null
      this.mounting.amount = null
      this.mounting.unit = null
      this.mounting.sn = null
      this.mounting.tag = null
      this.mounting.recId = null
      this.mounting.debitId = null
      this.mounting.consumptionId = null
      this.mounting.isSegment = false
      this.availableAmount = null
    }
  }
}

